// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3mssmpgZWen2UqIY","backdrop":"_3sG_nIF0SFMfynkX","open":"_3llPvDxiohES_r2Z","container":"_3Qm_OLRewzcglhn5","content":"_1cuCSR9ZipYyQR0X"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Menu/Menu.pcss
// module id = 473
// module chunks = 1